const COPY_TRANSACTION = 'copyTransaction'
const OPEN_NEW_TRANSACTION = 'openNewTransaction'
const DELETE_TRANSACTION = 'deleteTransaction'
const EDIT_TRANSACTION = 'editTransaction'
const OPEN_EDIT_TRANSACTION = 'openEditTransaction'
const CANCEL_EDIT_TRANSACTION = 'cancelEditTransaction'

const TRANSACTION_CREATED = 'transactionCreated'
const CREATE_TRANSACTION = 'createTransaction'
const TRANSACTION_UPDATED = 'transactionUpdated'
const PAGE_CHANGED = 'pageChanged'

const TRANSACTION_DRAFT_CREATED = 'transactionDraftCreated'
const TRANSACTION_DRAFT_UPDATED = 'transactionDraftUpdated'
const TRANSACTION_DRAFT_DELETED = 'transactionDraftDeleted'
const TRANSACTION_DRAFT_LOADED = 'transactionDraftLoaded'

// TODO move to where?
const SACC_LINES_UPDATED = 'saccLinesUpdated'

export {
    COPY_TRANSACTION,
    OPEN_NEW_TRANSACTION,
    DELETE_TRANSACTION,
    EDIT_TRANSACTION,
    OPEN_EDIT_TRANSACTION,
    CANCEL_EDIT_TRANSACTION,
    TRANSACTION_CREATED,
    TRANSACTION_UPDATED,
    PAGE_CHANGED,
    CREATE_TRANSACTION,
    SACC_LINES_UPDATED,
    TRANSACTION_DRAFT_CREATED,
    TRANSACTION_DRAFT_UPDATED,
    TRANSACTION_DRAFT_DELETED,
    TRANSACTION_DRAFT_LOADED
}